import { render, staticRenderFns } from "./BuddhaEducationalAnimation.vue?vue&type=template&id=2b57a8fc&"
import script from "./BuddhaEducationalAnimation.vue?vue&type=script&lang=js&"
export * from "./BuddhaEducationalAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports